
import { CreateOrUpdateBaseService } from '../../../../common/services/createOrUpdateBase.service';
import { services } from '../../../../constants/services';


export class CreateOrUpdateFileOrderService extends CreateOrUpdateBaseService<any, []> {
  url = `${services.rotationScreen}/setFilesOrder`;
}
